import { PixelCrop } from 'react-image-crop';

const TO_RADIANS = Math.PI / 180;

export async function createCanvasPreview(
    image: HTMLImageElement,
    canvas: HTMLCanvasElement,
    crop: PixelCrop,
    scale = 1,
    rotate = 0
) {
    const canvasContext = canvas.getContext('2d');

    if (!canvasContext) {
        throw new Error('No 2d context');
    }

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    // devicePixelRatio slightly increases sharpness on retina devices
    // at the expense of slightly slower render times and needing to
    // size the image back down if you want to download/upload and be
    // true to the images natural size.
    const pixelRatio = window.devicePixelRatio;
    // const pixelRatio = 1

    canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
    canvas.height = Math.floor(crop.height * scaleY * pixelRatio);

    canvasContext.scale(pixelRatio, pixelRatio);
    canvasContext.imageSmoothingQuality = 'high';

    const cropX = crop.x * scaleX;
    const cropY = crop.y * scaleY;

    const rotateRads = rotate * TO_RADIANS;
    const centerX = image.naturalWidth / 2;
    const centerY = image.naturalHeight / 2;

    canvasContext.save();

    // 5) Move the crop origin to the canvas origin (0,0)
    canvasContext.translate(-cropX, -cropY);
    // 4) Move the origin to the center of the original position
    canvasContext.translate(centerX, centerY);
    // 3) Rotate around the origin
    canvasContext.rotate(rotateRads);
    // 2) Scale the image
    canvasContext.scale(scale, scale);
    // 1) Move the center of the image to the origin (0,0)
    canvasContext.translate(-centerX, -centerY);
    canvasContext.drawImage(
        image,
        0,
        0,
        image.naturalWidth,
        image.naturalHeight,
        0,
        0,
        image.naturalWidth,
        image.naturalHeight
    );

    canvasContext.restore();
}
